import { useTranslation } from "@/hooks/useTranslation";
import {
  openSupportConversation,
  SUPPORT_EMAIL,
  useSupportMessengerReady,
} from "@/lib/support";
import { cn } from "@/lib/utils";

const SupportEmailLink = (): React.ReactElement => (
  <a
    href={`mailto:${SUPPORT_EMAIL}`}
    target="_blank"
    rel="noopener noreferrer"
    className="underline"
  >
    {SUPPORT_EMAIL}
  </a>
);

export const SupportMessage = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement => {
  const { t } = useTranslation();
  const isMessengerReady = useSupportMessengerReady();

  // Most screens carrying this message are blocking ones rendered *above* the
  // provider that boots the messenger (a fatal team-loading error, for one), so
  // the chat simply isn't there — point at the mailbox alone rather than at a
  // link that would do nothing.
  if (!isMessengerReady) {
    return (
      <p className={cn("text-center", className)}>
        {t("components.supportMessage.emailOnly")} <SupportEmailLink />{" "}
        {t("components.supportMessage.forHelp")}
      </p>
    );
  }

  return (
    <p className={cn("text-center", className)}>
      {t("components.supportMessage.text")}{" "}
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          openSupportConversation();
        }}
        className="underline"
      >
        {t("components.supportMessage.chatLink")}
      </a>{" "}
      {t("components.supportMessage.orByEmail")} <SupportEmailLink />{" "}
      {t("components.supportMessage.forHelp")}
    </p>
  );
};
